<template>
  <div>
     <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12 text-center mb-4">
              <h4 class="mb-0">
                ¿Alguno de nuestros colaboradores te invito a Hispano Club?
              </h4>
              <!-- <small>Los campos marcados con * son obligatorios. Y debes contar con al menos 18 años cumplidos</small> -->
            </div>
          </div>
         <div class="row">
             <div class="col-md-12">
                <vue-select-image
                  :dataImages="originSet"
                  @onselectimage="onSelectImage"
                  :useLabel="true"
                  :selectedImages="originSetInitial"
                  v-if="!userInLS || personalChoice === true"
                  >
                </vue-select-image>
                <div v-else>
                  <div class="container-fluid">
                    <div class="row align-items-center">
                      <div class="col-sm-12 text-center">
                        <div class="personal-sale-avatar" v-if="userInLS.avatar">
                          <img :src="userInLS.avatar.image" alt="" class="img-fluid">
                        </div>
                        <div class="d-inline-block" v-else>
                          <i class="fa fa-user-circle"></i>
                        </div>
                        <h4 class="mt-3">
                          <small>
                            {{userInLS.mlm_id}}
                          </small> <br>
                          {{userInLS.first_name}}
                          {{userInLS.last_name}}
                        </h4>
                      </div>
                    </div>
                    <div class="row align-items-center">
                      <div class="col-12 text-center">
                        <button class="btn btn-default btn-sm text-muted" @click="changeSelectionFromLocalStorage">
                          Cambiar Socio Patrocinador
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <pre>{{selectedImage}} </pre> -->
             </div>
         </div>

         <div class="row" >
            <div class="col-md-12">
              <div v-if="parseInt(selectedImage) === 1">
              </div>
              <div v-else-if="parseInt(selectedImage) === 2">
                Celebridad
              </div>
              <div v-else-if="parseInt(selectedImage) === 3">
                Socio
              </div>

              <div
                :class="{'is-invalid': $v.seller.seller_id.$invalid, 'form-group': true}"
                v-if="parseInt(selectedImage) === 2 || parseInt(selectedImage) === 3"
              >
                <label for="birthstate-input">{{$t('form.clave')}}</label>
                <input :type="inputKind"
                  class="form-control"
                  v-model="seller.seller_id"
                  @input="$v.seller.seller_id.$touch()"
                  :disabled="isDisabled"
                  placeholder="">
                <div class="form-control-feedback" v-if="!$v.seller.seller_id.required">
                {{ $t('form.required') }}
                </div>
              </div>
            </div>
         </div>
     </div>
     <!-- <pre>{{userInLS.mlm_id}}</pre> -->
      <!-- <pre>
        {{statusForm}}
      </pre> -->
  </div>
</template>

<script>
// eslint-disable-next-line
import Vue from 'vue'
// eslint-disable-next-line
import { validationMixin } from 'vuelidate'
// eslint-disable-next-line
import { required, minLength, maxLength, email, numeric} from 'vuelidate/lib/validators'

export default {
  name: 'FormStepOne',
  props: [
    'data'
  ],
  data () {
    return {
      step: 1,
      test: 'lorem',
      isValid: true,
      seller: {
        seller_id: ''
      },
      sendSeller: {
        seller_id: ''
      },
      inputKind: 'text',
      originSet: [{
        id: '1',
        src: 'https://www.hispanoclub.com/wp-content/uploads/2018/09/none_icon.jpg',
        alt: 'Ninguno'
      },
      // {
      //   id: '2',
      //   src: 'https://www.hispanoclub.com/wp-content/uploads/2018/09/celeb_icon.jpg',
      //   alt: 'Celebridades'
      // },
      {
        id: '3',
        src: 'https://www.hispanoclub.com/wp-content/uploads/2018/09/socios_icon.jpg',
        alt: 'Red de Socios'
      }],
      selectedImage: '1',
      // Local Storage
      userInLS: null,
      isDisabled: false,
      personalChoice: false,
      originSetInitial: [{
        id: '1',
        src: 'https://www.hispanoclub.com/wp-content/uploads/2018/09/none_icon.jpg',
        alt: 'Ninguno'
      }]
    }
  },
  validations () {
    if (parseInt(this.selectedImage) === 3) {
      return {
        seller: {
          seller_id: {
            required,
            numeric
          }
        }
      }
    } else {
      return {
        seller: {
          seller_id: {
            required
          }
        }
      }
    }
  },
  computed: {
    isSelling () {
      return this.$store.state.isSelling.process
    },
    isSellingIndex () {
      return this.$store.state.isSelling.index
    },
    statusForm () {
      return this.$v.seller.$invalid
    }
    // originSetInitial () {
    //   if (this.userInLS && this.userInLS.mlm_id) {
    //     return [{
    //       id: '3',
    //       src: 'https://www.hispanoclub.com/wp-content/uploads/2018/09/socios_icon.jpg',
    //       alt: 'Red de Socios'
    //     }]
    //   } else {
    //     return [{
    //       id: '1',
    //       src: 'https://www.hispanoclub.com/wp-content/uploads/2018/09/none_icon.jpg',
    //       alt: 'Ninguno'
    //     }]
    //   }
    // }
  },
  watch: {
    selectedImage (value) {
      if (parseInt(value) === 1) {
        this.sendSeller.seller_id = ''
        this.seller.seller_id = ''
        this.inputKind = 'text'
        this.isDisabled = false
      } else if (parseInt(value) === 2) {
        this.inputKind = 'text'
        this.seller.seller_id = ''
        this.isDisabled = false
      } else if (parseInt(value) === 3) {
        this.inputKind = 'number'
        if (this.userInLS && this.userInLS.mlm_id) {
          this.seller.seller_id = parseInt(this.userInLS.mlm_id)
          if (this.personalChoice === true) {
            this.isDisabled = false
          } else {
            this.isDisabled = true
          }
        } else {
          this.seller.seller_id = ''
          this.isDisabled = false
        }
      }
    },
    'seller.seller_id' (newVal, oldVal) {
      if (parseInt(this.selectedImage) === 2) {
        this.sendSeller.seller_id = newVal
      } else if (parseInt(this.selectedImage) === 3) {
        this.sendSeller.seller_id = 'socio-' + newVal
      }
    }
  },
  mounted () {
    this.getParterFromLocalStorage()
  },
  methods: {
    validate () {
      console.log('validando paso 2')
      if (parseInt(this.selectedImage) === 1) {
        this.$emit('on-validate', this.sendSeller.seller_id, this.isValid)
        return this.isValid
      } else if (parseInt(this.selectedImage) === 2 || parseInt(this.selectedImage) === 3) {
        this.$v.seller.$touch()
        this.isValid = !this.$v.seller.$invalid
        this.$emit('on-validate', this.sendSeller, this.isValid)
        return this.isValid
      }
    },
    onSelectImage (params) {
      console.log('imagen seleccionada', params)
      this.selectedImage = params.id
    },
    getParterFromLocalStorage () {
      let self = this
      self.userInLS = JSON.parse(Vue.localStorage.get('user'))
      self.selectedImage = 3
      console.log('existe en LS -> ', self.seller.seller_id)
    },
    changeSelectionFromLocalStorage () {
      let self = this
      self.selectedImage = 1
      self.personalChoice = true
    }
  }
}
/* {
  payment_token: 'tok_1Cm8XFG9eOPeXBTVIxjYNHIF',
  user: {
    username: 'test56ApiRest',
    password: 'Qwerty123'
  },
  data: {
    product_id: 406,
    payment_period: 'Mensual',
    first_name: 'Test56',
    last_name: 'ApiRest',
    email: 'test56apirest@yopmail.com',
    mobile_phone: '1234567890',
    address_1: 'Test Avenue',
    address_2: '1200',
    city: 'Houston',
    state: 'TX',
    postcode: '77001',
    birthdate: '1981-10-07',
    seller_id: 'socio-211',
    SSN: '234234234234',
    ITIN: '234234324234324'
  },
  add_kit: true
} */
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.vue-select-image {
  text-align: center
}
.vue-select-image__wrapper {
  display: inline-block;
}
.vue-select-image__img {
    width: 70px !important;
    height: 70px !important;
    margin: 20px auto 20px !important;
  }
.vue-select-image__thumbnail  {
  background: white !important;
  text-align: center;
  box-shadow: none;
  border:1px solid #ffffff !important;;
  transition:all 0.5s ease;
  width: 130px;
  &:hover {
    box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.20);
  }
}
.vue-select-image__thumbnail--selected {
  background: white !important;
  border:1px solid #7ED321 !important;
}
.personal-sale-avatar {
  width: 150px;
  height: 150px;
  margin:0 auto;
  overflow: hidden;
  border-radius: 100%;
  border:1px solid silver;
}
</style>



// WEBPACK FOOTER //
// src/components/FormStepTwo.vue